import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { useCart } from "./CartContext";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const { clearCart } = useCart();
  // Safepay returns `order_id`; our own PayPal redirect uses `orderId`.
  const orderId = params.get("orderId") || params.get("order_id");

  // Checkout deliberately keeps the cart until the customer gets here, so a
  // cancelled payment doesn't wipe it. Now that they're through, empty it.
  useEffect(() => {
    clearCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] bg-gray-50 px-6 text-center">
      <CheckCircle className="w-20 h-20 text-green-500 mb-6" />
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Thank you for your order!
      </h1>
      <p className="text-gray-600 max-w-md mb-2">
        We've received your order and are confirming your payment now. A
        confirmation email with the details is on its way.
      </p>
      {orderId && (
        <p className="text-sm text-gray-500 mb-8">
          Order reference: <span className="font-mono">{orderId}</span>
        </p>
      )}
      <Link
        to="/"
        className="bg-brand text-black font-semibold px-8 py-3 rounded-xl hover:bg-black hover:text-brand transition-all"
      >
        Continue Shopping
      </Link>
    </div>
  );
}
